import { formatDate, FormatDateType } from '../../../helpers/date';
import useIsMobile from '../../../hooks/useIsMobile/useIsMobile';
import {
  Carousel,
  CarouselButtonLeft,
  CarouselButtonRight,
  CarouselIndicators,
  CarouselItem,
  CarouselItems,
} from '../Carousel/Carousel';
import Clickable from '../Clickable/Clickable';
import { ClickableAction } from '../Clickable/consts';
import EventCard from '../EventCard/EventCard';
import styles from './EventCarousel.module.scss';
import type { EventCarouselProps } from './interfaces';

const EventCarousel = ({
  events,
  itemsPerSlideDefault = 3,
}: EventCarouselProps) => {
  const isMobile = useIsMobile(576);
  const isTablet = useIsMobile(992);
  const itemsPerPage = isMobile ? 1 : isTablet ? 2 : itemsPerSlideDefault;

  const carouselItems = (
    <CarouselItems>
      {events.map((event, index) => (
        <CarouselItem
          key={index}
          index={index}
          aria-roledescription="Event"
          className={styles.slide}
        >
          <Clickable
            actionType={ClickableAction.Linkintern}
            className={styles.link}
            linkintern={event.linkintern}
          >
            <EventCard
              date={formatDate(
                new Date(event.date),
                FormatDateType.EventArticle
              )}
              headline={event.headline}
              text={event.text}
              buttonText={event.buttonText}
              linkintern={event.linkintern}
            />
          </Clickable>
        </CarouselItem>
      ))}
    </CarouselItems>
  );

  return (
    <>
      <Carousel
        aria-label="Events"
        itemsPerPage={itemsPerPage}
        className={styles.mobile}
      >
        <div>{carouselItems}</div>
        <div className={styles.indicators}>
          <CarouselButtonLeft accessible={false} />
          <CarouselIndicators />
          <CarouselButtonRight accessible={false} />
        </div>
      </Carousel>
      <Carousel
        aria-label="Events"
        itemsPerPage={itemsPerPage}
        className={styles.desktop}
      >
        <div className={styles.items}>
          <CarouselButtonLeft accessible={false} />
          {carouselItems}
          <CarouselButtonRight accessible={false} />
        </div>
        <div>
          <CarouselIndicators />
        </div>
      </Carousel>
    </>
  );
};

export default EventCarousel;
